import { render, staticRenderFns } from "./ms-oneperson-prescription.vue?vue&type=template&id=909aa92a&scoped=true"
import script from "./ms-oneperson-prescription.vue?vue&type=script&lang=js"
export * from "./ms-oneperson-prescription.vue?vue&type=script&lang=js"
import style0 from "./ms-oneperson-prescription.vue?vue&type=style&index=0&id=909aa92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909aa92a",
  null
  
)

export default component.exports